/**
 *
 * Themes
 */
export const THEME_LIGHT = 'Theme/Light';
export const THEME_DARK = 'Theme/Dark';

/**
 *
 * Regions
 */
export const REGION_PAGES = 'Region/Pages';
export const REGION_CHAPTERS = 'Region/Chapters';
export const REGION_OVERLAYS = 'Region/Overlays';

/**
 *
 * Layouts
 */
export const LAYOUT_MAIN = 'Layout/Main';

/**
 *
 * Button
 */
export const BUTTON_PRIMARY = 'button-primary';
export const BUTTON_SECONDARY = 'button-secondary';
export const BUTTON_TERTIARY = 'button-tertiary';

/**
 *
 * Media
 */
export const MEDIA_TYPE_IMAGE = 'image';
export const MEDIA_TYPE_SPRITESHEET = 'spritesheet';
export const MEDIA_TYPE_VIDEO = 'video';

/**
 *
 * Sections
 */
export const SECTION_360 = 'section-360';
export const SECTION_AIR_DREAM_EDITION = 'section-air-dream-edition';
export const SECTION_AIR_INTRO = 'section-air-intro';
export const SECTION_BANNER = 'section-banner';
export const SECTION_COLLAGE = 'section-collage';
export const SECTION_CONFIGURATOR_EXTERIOR = 'section-configurator-exterior';
export const SECTION_CONFIGURATOR_INTERIOR = 'section-configurator-interior';
export const SECTION_DREAMDRIVE = 'section-dreamdrive';
export const SECTION_EDITORIAL_CONTENT = 'section-editorial-content';
export const SECTION_EXPANDABLE_CHAPTER = 'section-expandable-chapter';
export const SECTION_EXPANDABLE_CHAPTERS = 'section-expandable-chapters';
export const SECTION_FAQ = 'section-faq';
export const SECTION_GALLERY = 'section-gallery';
export const SECTION_HEADER_GENERIC = 'section-header-generic';
export const SECTION_HERO_AIR = 'section-hero-air';
export const SECTION_HERO_AIR_DREAM_EDITION = 'section-hero-air-dream-edition';
export const SECTION_HERO_CHAPTER = 'section-hero-chapter';
export const SECTION_HERO_GENERIC = 'section-hero-generic';
export const SECTION_HERO_HOME = 'section-hero-home';
export const SECTION_HERO_SUV = 'section-hero-suv';
export const SECTION_HOME_VIDEO = 'section-home-video';
export const SECTION_HOTSPOTS = 'section-hotspots';
export const SECTION_INSPIRATION = 'section-inspiration';
export const SECTION_LINEUP = 'section-lineup';
export const SECTION_MAP = 'section-map';
export const SECTION_MATERIALS = 'section-materials';
export const SECTION_MEDIA = 'section-media';
export const SECTION_MEDIA_REVEAL = 'section-media-reveal';
export const SECTION_MEDIA_WITH_CARD = 'section-media-with-card';
export const SECTION_MEDIA_WITH_PARAGRAPH = 'section-media-with-paragraph';
export const SECTION_MODELS = 'section-models';
export const SECTION_PARAGRAPH_ONE_COLUMN = 'section-paragraph-one-column';
export const SECTION_PARAGRAPH_ONE_COLUMN_LARGE =
  'section-paragraph-one-column-large';
export const SECTION_PARAGRAPH_TWO_COLUMNS = 'section-paragraph-two-columns';
export const SECTION_PARAGRAPH_TWO_COLUMNS_WITH_MEDIA =
  'section-paragraph-two-columns-with-media';
export const SECTION_PARAGRAPH_TWO_COLUMNS_WITH_NOTE =
  'section-paragraph-two-columns-with-note';
export const SECTION_PARAGRAPH_TWO_COLUMNS_WITH_THUMBNAIL =
  'section-paragraph-two-columns-with-thumbnail';
export const SECTION_REVERSIBLE = 'section-reversible';
export const SECTION_SIGNUP = 'section-signup';
export const SECTION_SLIDER = 'section-slider';
export const SECTION_SLIDESHOW = 'section-slideshow';
export const SECTION_SPECS = 'section-specs';
export const SECTION_STATS = 'section-stats';
export const SECTION_STATS_SIMPLE = 'section-stats-simple';
export const SECTION_STORIES = 'section-stories';
export const SECTION_TABS = 'section-tabs';
export const SECTION_VIDEO = 'section-video';

/**
 *
 * Parallax
 */
export const PARALLAX_VARIANT_NARROW = 'narrow';
export const PARALLAX_VARIANT_REGULAR = 'regular';

/**
 *
 * Spritesheet
 */
export const SPRITESHEET_CONTROL_SCROLL = 'scroll';
export const SPRITESHEET_CONTROL_SLIDER = 'slider';

/**
 *
 * Breakpoints
 */
export const BREAKPOINT_REGULAR = 1024;

/**
 *
 * Map filter types
 */

export const MAP_FILTER_STUDIO = 'studio';
export const MAP_FILTER_CHARGING = 'charging-station';

/**
 *
 * Colors
 */

export const COLOR_BLACK = '#1b1b1b';
export const COLOR_WHITE = '#ffffff';
